import { search } from './util/searchClient.js';
import { startAutocomplete } from './widgets/autocomplete.js';
import { widgets } from './widgets/index.js';
import { configs } from './widgets/config.js';
import { facetWidget } from './widgets/facet.js';
import { configure } from '../../../../dist/vendor/instantsearch.js/es/widgets/index.js';
import { opts } from './opts.js';
import { isArchivePage, isSearchPage } from './util/helpers.js';

export class AlgoliaSearch {

	constructor( node, options = {} ) {
		if ( ! node ) { return; }
		this.opts = {
			...opts.base,
			...options,
		};
		this.node = node;
		this.init();
	}

	init() {
		const { searchWrap } = this.opts.selectors;
		// this.errorReporting();
		// this.insights();
		this.search = search;
		this.wrap = this.node.querySelector(searchWrap);
		this.attributes = [...this.node.attributes];
		this.gatherRequirements();
		this.prepareWidgets();
		this.start();
	}

	start() {
		this.search.start();
		this.requires['autocomplete']
			&& startAutocomplete(this.search);
	}

	gatherRequirements() {

		this.configs = Object.keys(configs).map(c => c.toLowerCase());
		this.widgets = Object.keys(widgets).map(w => w.toLowerCase());

		const withConfig = this.attributes
			.filter(({ name }) => this.configs.indexOf(name) > -1)
			.filter(Boolean);

		const withWidget = this.attributes
			.filter(({ name }) => this.widgets.indexOf(name) > -1)
			.filter(Boolean);

		this.requires = [
			// real widgets have both a widget and a config
			...withWidget
				.filter(item => withConfig.includes(item))
				.flatMap(item => this.widgetName(item)),
			// virtual widgets have a matching widget, but no config
			...withWidget
				.filter(name => !withConfig.includes(name))
				.flatMap(item => this.widgetName(item)),

		];
	}

	prepareWidgets() {
		const { taxonomy, postType, taxonomyLabel } = this.node.dataset;

		const facets = [
			{
				slug: 'post_type_label',
				label: 'Content Type',
				attribute: 'post_type_label'
			},
			{
				slug: 'category',
				label: 'Category',
				attribute: 'taxonomies.category'
			},
			{
				slug: 'mec_category',
				label: 'Event Categories',
				attribute: 'taxonomies.mec_category'
			}
		];

		const facetWidgets = facets.map( facet => facetWidget( facet ) ).filter(Boolean);

		this.search.addWidgets([
			configure(opts.configure),

			// required widgets
			...this.requires.map(name => widgets[name](
				configs[name]
				? {
					...configs[name],
					container: this.container(configs[name]),
				}
				: {
					// virtualMenu still requires an attribute (arbitrary value I assume)
					attribute: name
				}
			)).filter(Boolean),

			// facet widgets
			...facetWidgets.map(({ params, widget }) => widget({
				...params,
				container: this.container(params),
			}))
		]);
	}

	container({ location, container }) {
		const el = document.createElement('div');
		el.classList = `${this.opts.classes.facet} ${container.replace('.', '')}`;
		return this.node.querySelector(`.${location}`).appendChild(el);
	}

	widgetName({ nodeName }) {
		return Object.keys(widgets).filter(w => nodeName === w.toLowerCase());
	}

	errorReporting() {
		this.search.on('render', () => console.log(this.search.status));
		this.search.on('error', err => console.log(this.search.status, err));
	}
}


document.addEventListener( 'DOMContentLoaded', () => {
	const block = document.querySelector('.algolia__block');


	// block OR header search, NOT both.
	if (block || isSearchPage || isArchivePage) {

		// if block exists, replace masthead search button with a search reset link.
		const el = document.querySelector('.masthead__action.masthead__search-icon');
		const urlParts = location.href.match(/^(.*?)\/site-search/);
        const base = `${urlParts ? urlParts[1] : ''}/`;

		// clone to remove all existing event listeners
		const clone = el.cloneNode(true);
		clone.addEventListener('click', () => {
			window.location.href = `${base}site-search/`
		});
		el.parentNode.replaceChild(clone, el);

		new AlgoliaSearch( block );
		return;

	} else {
		const header = document.querySelector('.algolia__masthead');
		if (header) {
			new AlgoliaSearch( header );
			return;
		}
	}
});
